import { Card, Descriptions, Tag } from "antd";
import PropTypes from "prop-types";

const ModeleDetails = ({ modele }) => {
	return (
		<Card>
			<Descriptions bordered column={{ sm: 1, lg: 2, xl: 3 }}>
				<Descriptions.Item label='Nom'>
					{modele?.nom ?? "N/A"}
				</Descriptions.Item>
				<Descriptions.Item label='Code'>
					{modele?.code ?? "N/A"}
				</Descriptions.Item>
				<Descriptions.Item label='Statut'>
					{modele?.enabled ? (
						<Tag color='success'>Actif</Tag>
					) : (
						<Tag color='error'>Inactif</Tag>
					)}
				</Descriptions.Item>
				<Descriptions.Item label='Couleur'>
					{modele?.couleur ? (
						<Card classNames={{ body: "p-2" }}
							style={{
								background: modele.couleur,
								width: "50%",
							}}
						></Card>
					) : (
						"N/A"
					)}
				</Descriptions.Item>
			</Descriptions>
			<Descriptions bordered>
				<Descriptions.Item label='Description'>
					<div style={{ whiteSpace: "pre-wrap" }}>
						{modele?.description ?? "N/A"}
					</div>
				</Descriptions.Item>
			</Descriptions>
		</Card>
	);
};

export default ModeleDetails;

ModeleDetails.propTypes = {
	modele: PropTypes.object,
};
